import { experimentalMutate } from '@confluence/legacy-schema-bridge/entry-points/experimentalMutate.ts';
import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloCompatibleMutationResult } from '@confluence/apollo-relay-interop/entry-points/apolloCompatibleMutation.ts';

export const experimentalFileUploadMutate = ({
	variables,
}: {
	variables: any;
}): Promise<ApolloCompatibleMutationResult<FileUploadMutation>> => {
	return experimentalMutate<
		FileUploadMutation,
		FileUploadMutationVariables,
		FileUploadMutationResponse
	>({
		url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
		method: 'POST',
		body: JSON.stringify(variables),
		headers: {
			'Content-Type': MediaType.JSON,
		},
		variables,
		parseResult: () => ({
			experimentalFileUpload: true,
		}),
	});
};
interface FileUploadMutation {
	experimentalFileUpload: boolean | null;
}
interface FileUploadMutationVariables {
	size: number;
	contentType: string;
	mimeType: string;
	fileName: string;
	pageId: string;
	fileStoreId: string;
	minorEdit?: boolean | null;
	renderEditorHTML?: boolean | null;
	collectionName: string;
	uploadSource?: string | null;
}
interface FileUploadMutationResponse {
	id: string;
	htmlForEditor: string;
}
